import React, { Component } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import SidebarHorizontal from "./layout/SideBar/SidebarHorizontal";
import NavbarHorizontal from "./layout/NavBar/NavbarHorizontal";
import "./App.css";
//import Invoice from './view/Invoice/Invoice';
import Accounting from './view/Accounting/Accounting';
import Login from './view/Account/Account';
import ExternalOperation from './view/Account/ExternalOperation';
import Profile from './view/Profile/Profile';
import Shipment from './view/Shipment/Shipment';
import Appointment from './view/Appointment/Appointment';
import Creditability from './view/Creditability/Creditability';
import Sales from './view/Sales';
import PaymentOptions from './view/PaymentOptions/PaymentOptions';
import FactoringManagement from './view/Factoring/FactoringManagement';
import { ToastContainer } from "react-toastify";
import { library } from '@fortawesome/fontawesome-svg-core'
//import { fab } from '@fortawesome/free-solid-svg-icons'
import { faFileExcel, faFileCode, faMoneyCheck } from '@fortawesome/free-solid-svg-icons'

library.add(faFileExcel, faFileCode, faMoneyCheck);

class App extends Component {
    static initialData = {
        minaylaURL: "https://minayla.com/"
    };
    render() {
        const currentPath = window.location.href;

        if (currentPath.toLowerCase().includes("/externaloperation?ref="))
            return (<BrowserRouter>
                <Switch>
                    <ExternalOperation />
                </Switch>
            </BrowserRouter>
            );
        if (currentPath.includes("/creditability?ref=")) {
            return (
                <BrowserRouter>
                    <Switch>
                        <Creditability />
                    </Switch>
                </BrowserRouter>
            )
        }

        if (currentPath.includes("/login") || !localStorage.getItem("authToken")) {
            return (<BrowserRouter>
                <Switch>
                    <Login />
                </Switch>
            </BrowserRouter>
            );
        }


        return (
            <div className="container-fluid">
                <ToastContainer autoClose={3000} />
                <div className="row">
                    <NavbarHorizontal />
                    <div className="right-column">
                        <SidebarHorizontal />
                        <Switch>
                            <Route exact path="/" component={Shipment} />
                            <Route exact path="/accounting" component={Accounting} />
                            <Route exact path="/deliveryorder" component={Shipment} />
                            <Route exact path="/profile" component={Profile} />
                            <Route exact path="/appointment" component={Appointment} />
                            <Route exact path="/creditability" component={Creditability} />
                            <Route exact path="/sales" component={Sales} />
                            <Route exact path="/mycards" component={PaymentOptions} />
                            <Route exact path="/factoring" component={FactoringManagement} />
                        </Switch>
                    </div>
                </div>
            </div>
        );
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js